import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import ko from "dayjs/locale/ko";
import {ActvLogModel} from "app/model/common/actvLogModel";
import {CoService} from "app/services/common/CoService";
import {Constant} from "app/constants/constant";
import {ResponseResultCode} from "../../../model/response-api";
import DashboardLoading from "./DashboardLoading";
import DashboardNoData from "./DashboardNoData";
import DashboardCard from "./DashboardCard";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";

export default function ActivityFeed(props: Readonly<DashboardModuleProps>) {
  dayjs.extend(relativeTime);
  dayjs.extend(utc);
  dayjs.locale(ko);

  const [activityFeeds, setActivityFeeds] = useState<ActvLogModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    CoService.getInstance().getUsersActvFeeds().then(response => {
      if (response && response.resultCode === ResponseResultCode.Y) {
        setActivityFeeds(response.data);
      } else {
        setActivityFeeds([]);
      }
    })
    .catch(() => {
      setActivityFeeds([]);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  return (
    <DashboardCard
      title="활동 피드"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={false}
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading} />
      <div className="txt-box-row">
        {activityFeeds.length > 0 ? (
          activityFeeds.map((log) => (
            <div key={log.logId} className="txt-box">
              <span className="t1">{log.logMsgCtt}</span>
              <span className="t2">
                {dayjs(log.regDate).utc(true).local().format(Constant.FORMAT_FULL)}
                <strong>{dayjs(log.regDate).utc(true).local().fromNow()}</strong>
              </span>
            </div>
          ))
        ) : (
          <DashboardNoData message="활동 피드가 없습니다." />
        )}
      </div>
    </DashboardCard>
  );
}